import React, {useState} from "react";
import {ProjectOrderByContext} from "./project-order-by-context-props.ts";
import {OrderByType} from "./models/order-by-type.ts";

const ProjectOrderByProvider: React.FC<React.PropsWithChildren> = ({children}) => {

    const [orderBy, setOrderBy] = useState<OrderByType>("name_asc");
    
    const contextProps = {
        orderBy,
        setOrderBy
    }
    
    return (
        <ProjectOrderByContext.Provider value={contextProps}>
            {children}
        </ProjectOrderByContext.Provider>
    )
};

export default ProjectOrderByProvider;